import {
    Plus,
    Download,
    RefreshCw,
    ChevronRight,
} from "lucide-react";

import "./FoodHeader.css";

function FoodHeader({ totalFoods, onRefresh }) {
    return (
        <div className="food-header-container">

            <div className="food-header-top">

                <div>

                    <div className="breadcrumb">

                        Dashboard

                        <ChevronRight size={16} />

                        Food Management

                    </div>

                    <h1>Food Management</h1>

                    <p>
                        Manage all foods added by providers across the platform.
                    </p>

                </div>

                <div className="food-header-actions">

                    <button
                        className="refresh-btn"
                        onClick={onRefresh}
                    >
                        <RefreshCw size={18} />
                        Refresh
                    </button>

                    <button className="export-btn">

                        <Download size={18} />

                        Export

                    </button>

                    <button className="add-food-btn">

                        <Plus size={18} />

                        Add Food

                    </button>

                </div>

            </div>

            <div className="food-header-summary">

                <div className="summary-card">

                    <h2>{totalFoods}</h2>

                    <span>Total Foods</span>

                </div>

                <div className="summary-text">

                    View, search, filter and manage every food listed by providers.

                </div>

            </div>

        </div>
    );
}

export default FoodHeader;